import React, { useEffect, useRef } from 'react';

interface ShareModalProps {
  shareUrl: string;
  onClose: () => void;
  onCopy: () => void;
}

export const ShareModal: React.FC<ShareModalProps> = ({
  shareUrl,
  onClose,
  onCopy,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<Element | null>(null);

  useEffect(() => {
    triggerRef.current = document.activeElement;
    modalRef.current?.focus();
    return () => {
      if (triggerRef.current instanceof HTMLElement) {
        triggerRef.current.focus();
      }
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="dialog-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Share itinerary">
      <div className="dialog share-dialog" ref={modalRef} tabIndex={-1} onClick={(e) => e.stopPropagation()}>
        <h3>Share Itinerary</h3>
        <p>Anyone with this link can view this itinerary:</p>
        <div className="share-link-container">
          <input
            type="text"
            value={shareUrl}
            readOnly
            className="share-link-input"
            aria-label="Share link URL"
          />
          <button onClick={onCopy} className="copy-btn">
            Copy
          </button>
        </div>
        <div className="dialog-actions">
          <button onClick={onClose} className="btn-cancel">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
